export const IMAGECONFIG = {
    CHART27ICON: require('../images/chart-icons/open_chart.png'),
    CHART27ICONBLUE: require('../images/chart-icons/open_chart_blue.png'),

    CHART1ICON: require('../images/table-icon.png'),
    CHART1ICONBLUE: require('../images/table-icon-blue.png'),

    CHART2ICON: require('../images/chart-icons/basic-line-gray.png'),
    CHART2ICONBLUE: require('../images/chart-icons/basic-line-blue.png'),

    CHART3ICON: require('../images/chart-icons/stacked-column-gray.png'),
    CHART3ICONBLUE: require('../images/chart-icons/stacked-column-blue.png'),

    CHART4ICON: require('../images/chart-icons/synchronised-chart-gray.png'),
    CHART4ICONBLUE: require('../images/chart-icons/synchronised-chart-blue.png'),

    CHART5ICON: require('../images/chart-icons/column-gray.png'),
    CHART5ICONBLUE: require('../images/chart-icons/column-blue.png'),

    CHART6ICON: require('../images/chart-icons/area-chart-gray.png'),
    CHART6ICONBLUE: require('../images/chart-icons/area-chart-blue.png'),

    CHART7ICON: require('../images/chart-icons/multi-axis-gray.png'),
    CHART7ICONBLUE: require('../images/chart-icons/multi-axis-blue.png'),

    CHART8ICON: require('../images/chart-icons/sparkline-gray.png'),
    CHART8ICONBLUE: require('../images/chart-icons/sparkline-blue.png'),

    CHART9ICON: require('../images/chart-icons/bubble-split-gray.png'),
    CHART9ICONBLUE: require('../images/chart-icons/bubble-split-blue.png'),

    CHART10ICON: require('../images/chart-icons/treemap-gray.png'),
    CHART10ICONBLUE: require('../images/chart-icons/treemap-blue.png'),

    CHART11ICON: require('../images/chart-icons/bubble-radial-gray.png'),
    CHART11ICONBLUE: require('../images/chart-icons/bubble-radial-blue.png'),
    
    CHART12ICON: require('../images/chart-icons/pie-chart-gray.png'),
    CHART12ICONBLUE: require('../images/chart-icons/pie-chart-blue.png'),

    CHART13ICON: require('../images/chart-icons/pie-chart-gray.png'),
    CHART13ICONBLUE: require('../images/chart-icons/pie-chart-blue.png'),

    CHART14ICON: require('../images/chart-icons/column-drilldown-chart-gray.png'),
    CHART14ICONBLUE: require('../images/chart-icons/column-drilldown-chart-blue.png'),

    CHART15ICON: require('../images/chart-icons/scatter-gray.png'),
    CHART15ICONBLUE: require('../images/chart-icons/scatter-blue.png'),

    CHART16ICON: require('../images/chart-icons/variwide-chart-gray.png'),
    CHART16ICONBLUE: require('../images/chart-icons/variwide-chart-blue.png'),

    CHART17ICON: require('../images/chart-icons/variable-radius-chart-gray.png'),
    CHART17ICONBLUE: require('../images/chart-icons/variable-radius-chart-blue.png'),

    CHART18ICON: require('../images/chart-icons/combo-chart-gray.png'),
    CHART18ICONBLUE: require('../images/chart-icons/combo-chart-blue.png'),
    
    CHART19ICON: require('../images/chart-icons/bar-chart-gray.png'),
    CHART19ICONBLUE: require('../images/chart-icons/bar-chart-blue.png'),

    CHART20ICON: require('../images/chart-icons/stacked-bar-gray.png'),
    CHART20ICONBLUE: require('../images/chart-icons/stacked-bar-blue.png'),

    CHART21ICON: require('../images/chart-icons/basic-line-gray.png'),
    CHART21ICONBLUE: require('../images/chart-icons/basic-line-blue.png'),

    CHART22ICON: require('../images/chart-icons/line-column-combo.png'),
    CHART22ICONBLUE: require('../images/chart-icons/line-column-combo-blue.png'),

    CHART23ICON: require('../images/chart-icons/stacked-bar-gray.png'),
    CHART23ICONBLUE: require('../images/chart-icons/stacked-bar-blue.png'),

    CHART24ICON: require('../images/chart-icons/stacked-column-gray.png'),
    CHART24ICONBLUE: require('../images/chart-icons/stacked-column-blue.png'),

    CHART25ICON: require('../images/chart-icons/column-gray.png'),
    CHART25ICONBLUE: require('../images/chart-icons/column-blue.png'),

    CHART26ICON: require('../images/chart-icons/bar-chart-gray.png'),
    CHART26ICONBLUE: require('../images/chart-icons/bar-chart-blue.png'),

    GREENINCREASE:require('../images/green-up.png'),
    REDDECREASE:require('../images/red-decrease.png'),
    BOTROBOT:require('../images/bot_robot.png'),
    BEAGLETEAMS:require('../images/beagle_teams.png'),
    HOMEBACKGROUND:require('../images/beagle_home_back.png'),
    HOMEBODYINFO:require('../images/home_body_info.png'),
    HOMEBODYINFOMOBILE:require('../images/home-body-info-mobile.png'),
    ERRORFALLBACK:require('../images/teams-fallback.gif'),
    ACCESSFALLBACK:require('../images/cancel.gif'),
    DOWNLOAD:require('../images/download.svg').default,
}